import {createReducer} from 'redux-act';
import {PRODUCT} from 'constants/actions';
import {ProductReviewsType, ProductReviewType} from 'reducers/product/reviews/reviewsType';
import {AxiosResponse} from 'axios';

export const initialState: ProductReviewsType = {
    status: '',
    statusSendingReview: '',
    count: 0,
    rating: 0,
    items: [],
    isPreloaded: false,
};

/**
 * Reviews reducer
 */
export const reviews = createReducer<ProductReviewsType>({}, initialState)
    .on(
        `${PRODUCT.FETCH_REVIEWS}_FULFILLED`,
        (
            state: ProductReviewsType,
            payload: AxiosResponse<{
                count: number;
                summary: number;
                isPreloaded: boolean;
                reviews: Array<ProductReviewType>;
            }>,
        ): ProductReviewsType => {
            const {data} = payload;

            return {
                ...state,
                status: 'fulfilled',
                count: data.count,
                rating: data.summary,
                items: [...state.items, ...data.reviews],
                isPreloaded: Boolean(data.isPreloaded),
            };
        },
    )
    .on(
        `${PRODUCT.FETCH_REVIEWS}_PENDING`,
        (state: ProductReviewsType): ProductReviewsType => ({
            ...state,
            status: 'pending',
        }),
    )
    .on(
        `${PRODUCT.FETCH_REVIEWS}_REJECTED`,
        (state: ProductReviewsType): ProductReviewsType => ({
            ...state,
            status: 'rejected',
        }),
    )

    .on(
        `${PRODUCT.SEND_REVIEW}_PENDING`,
        (state: ProductReviewsType): ProductReviewsType => ({
            ...state,
            statusSendingReview: 'pending',
        }),
    )
    .on(
        `${PRODUCT.SEND_REVIEW}_FULFILLED`,
        (state: ProductReviewsType): ProductReviewsType => ({
            ...state,
            statusSendingReview: 'fulfilled',
        }),
    )
    .on(
        `${PRODUCT.SEND_REVIEW}_REJECTED`,
        (state: ProductReviewsType): ProductReviewsType => ({
            ...state,
            statusSendingReview: 'rejected',
        }),
    )
    .on(
        PRODUCT.CLEAR_SENDING_STATUS_REVIEW,
        (state: ProductReviewsType): ProductReviewsType => ({
            ...state,
            statusSendingReview: '',
        }),
    )
    .on(PRODUCT.CLEAR_REVIEWS, () => initialState);
